<app-template [useCard]="true" title="Informe seu email">

  <form class="p-grid ui-fluid p-col-12 col-md-6" [formGroup]="userForm" (submit)="save(userForm.value)">
    <div class="p-col-12 form-group stacked">
      <label for="nome">E-mail *</label>
      <input maxlength="100" pInputText formControlName="mail" type="email">
      <app-input-message [form]="userForm" field="mail"></app-input-message>
    </div>

    <div class="actions p-col-12 align-right">
      <button type="button" class="btn-primary" (click)="back()">
        Cancelar
      </button>
      <button class="btn-primary" type="submit" [disabled]="userForm.invalid">
        Enviar
      </button>
    </div>
  </form>

</app-template>
